document.addEventListener('DOMContentLoaded', function() {
  const collectionMenu = document.getElementById('collectionMenu');
  const collectionList = collectionMenu ? collectionMenu.querySelector('.collection-list') : null;
  const collectionProducts = document.getElementById('collectionProducts');

  if (!collectionProducts) return;

  const productLimit = parseInt(collectionProducts.dataset.productLimit, 10) || 12;

  // Function to fetch collection products
  function fetchCollectionProducts(collectionHandle) {
    const url = `/collections/${collectionHandle}/products.json?limit=${productLimit}`;

    fetch(url)
      .then(response => response.json())
      .then(data => {
        renderProducts(data.products);
      })
      .catch(error => {
        console.error('Error fetching collection products:', error);
      });
  }

  // Function to render products
  function renderProducts(products) {
    collectionProducts.innerHTML = ''; // Clear previous products

    const limitedProducts = products.slice(0, productLimit);

    limitedProducts.forEach(product => {
      const imageUrl = product.images.length > 0 ? product.images[0].src : 'path/to/default-image.jpg';
      const price = product.variants[0].price;
      const compareAtPrice = product.variants[0].compare_at_price ? product.variants[0].compare_at_price : null;

      let priceHTML = `$${price}`;
      if (compareAtPrice) {
        priceHTML = `<span style="text-decoration: line-through;">$${compareAtPrice}</span> $${price}`;
      }

      const productHTML = `
        <div class="product-card add-to-cart product-card-gift grid__item" data-variant-id="${product.variants[0].id}">
          <img src="${imageUrl}" alt="${product.title}">
          <div class="product-card-gift--content">
            <div class="prod-title">${product.title}</div>
            <div class="price"><b>${priceHTML}</b></div> 
          </div>
        </div>
      `;
      collectionProducts.innerHTML += productHTML;
    });

    document.querySelectorAll('.add-to-cart').forEach(button => {
      button.addEventListener('click', function() {
        const variantId = this.getAttribute('data-variant-id');
        addToCart(variantId);
      });
    });
  }

  // Function to display popup notice
  function showPopup(message, isSuccess = true) {
    const popup = document.createElement('div');
    popup.className = `popup-notice ${isSuccess ? 'success' : 'error'}`;
    popup.textContent = message;
    document.body.appendChild(popup);

    setTimeout(() => {
      popup.classList.add('show');
    }, 10);

    setTimeout(() => {
      popup.classList.remove('show');
      setTimeout(() => {
        document.body.removeChild(popup);
      }, 300);
    }, 3000);
  }

  // Function to add to cart
  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      showPopup(`${data.title} successfully added to cart`, true);
      updateCart();
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      showPopup('Failed to add product to cart. Please try again.', false);
    });
  }

  // Function to update cart drawer and icon bubble without opening the drawer
  function updateCart() {
    fetch('/cart?view=drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Update the cart drawer content
        const cartDrawer = document.querySelector('cart-drawer,#CartDrawer, [data-cart-drawer]');
        if (cartDrawer) {
          const newDrawerContent = doc.querySelector('cart-drawer,#CartDrawer, [data-cart-drawer]').innerHTML;
          cartDrawer.innerHTML = newDrawerContent;

          // Remove the .is-empty class if the cart has items
          const cartItems = cartDrawer.querySelectorAll('.cart-item');
          if (cartItems.length > 0) {
            cartDrawer.classList.remove('is-empty');
          }
        } else {
          console.error('Cart drawer element not found');
        }

        // Update the cart icon bubble
        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        if (cartIconBubble) {
          const newBubbleContent = doc.querySelector('#cart-icon-bubble').innerHTML;
          cartIconBubble.innerHTML = newBubbleContent;
        } else {
          console.error('Cart icon bubble not found');
        }
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
      });
  }

  // Resolve the occasion the customer is shopping for.
  // Only a stored collection visit counts. Product membership does not, so a
  // product opened from search keeps the default upsell collections.
  // A stored visit applies only when this product belongs to that collection.
  // When it sits in several, the most recent matching visit wins.
  function resolveIntent() {
    const ownCollections = (collectionMenu.getAttribute('data-product-collections') || '')
      .split(',')
      .filter(Boolean);

    if (!window.FFEIntent || typeof window.FFEIntent.getForCollections !== 'function') {
      return null;
    }

    const candidate = window.FFEIntent.getForCollections(ownCollections);
    if (!candidate || !Array.isArray(candidate.tabs)) return null;

    const tabs = candidate.tabs.filter(function(tab) {
      return tab && tab.handle && ownCollections.indexOf(tab.handle) === -1;
    });

    return tabs.length ? Object.assign({}, candidate, { tabs: tabs }) : null;
  }

  function getSeeAllButton() {
    return collectionMenu ? collectionMenu.querySelector('.upsell-see-all') : null;
  }

  function updateCategoryVisibility() {
    if (!collectionList) return;

    const visibleTabs = collectionList.querySelectorAll('.collection-list--item');
    collectionList.hidden = visibleTabs.length <= 1;
  }

  function renderIntentMenu(intent) {
    // Keep the block's other tabs so "see all" can append them after the
    // intent ones, rather than replacing what the customer is looking at.
    const remainingTabs = Array.prototype.filter.call(
      collectionList.querySelectorAll('.collection-list--item'),
      function(item) {
        const handle = item.getAttribute('data-handle');
        return !intent.tabs.some(function(tab) {
          return tab.handle === handle;
        });
      }
    );

    collectionList.innerHTML = intent.tabs
      .map(function(tab, index) {
        const title = tab.upsell_title || tab.title || tab.handle;
        const image = tab.image
          ? `<img src="${tab.image}" alt="${title}" />`
          : '';
        return `
          <a href="javascript:void(0);" class="grid__item collection-list--item${index === 0 ? ' selected' : ''}" data-handle="${tab.handle}">
            ${image}
            <div class="collection-title">${title}</div>
          </a>
        `;
      })
      .join('');

    collectionMenu.removeAttribute('data-upsell-default');

    const seeAllButton = collectionMenu.querySelector('.upsell-see-all');
    if (!seeAllButton || !remainingTabs.length) return;

    seeAllButton.hidden = false;
    seeAllButton.addEventListener(
      'click',
      function() {
        remainingTabs.forEach(function(item) {
          item.classList.remove('selected');
          collectionList.appendChild(item);
        });
        seeAllButton.hidden = true;
      },
      { once: true }
    );
  }

  // Initialize collection handle and load initial products
  function initializeCollectionHandle() {
    const intent = collectionList ? resolveIntent() : null;

    if (intent) {
      renderIntentMenu(intent);
      fetchCollectionProducts(intent.tabs[0].handle);
      return;
    }

    // No intent: keep the server-rendered tabs and the original default.
    const defaultHandle = 'extra-wow';
    const defaultItem = collectionList
      ? collectionList.querySelector(`.collection-list--item[data-handle="${defaultHandle}"]`)
      : null;
    if (defaultItem) defaultItem.classList.add('selected');
    fetchCollectionProducts(defaultHandle);
  }

  initializeCollectionHandle();

  // Delegated so it survives the menu being rebuilt from intent data.
  if (collectionMenu) {
    collectionMenu.addEventListener('click', function(event) {
      const target = event.target;
      const item = target && target.closest ? target.closest('.collection-list--item') : null;
      if (!item) return;

      collectionMenu.querySelectorAll('.collection-list--item').forEach(function(el) {
        el.classList.remove('selected');
      });
      item.classList.add('selected');

      const collectionHandle = item.getAttribute('data-handle');
      if (collectionHandle) {
        fetchCollectionProducts(collectionHandle);
      }
    });
  }
});

// CSS for the popup notice
const style = document.createElement('style');
style.textContent = `
  .popup-notice {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #4caf50;
    color: white;
    padding: 15px;
    border-radius: 5px;
    font-size: 16px;
    opacity: 0;
    transition: opacity 0.3s, bottom 0.3s;
    z-index: 1000;
  }

  .popup-notice.error {
    background-color: #f44336;
  }

  .popup-notice.show {
    opacity: 1;
    bottom: 40px;
  }

  @media (max-width: 600px) {
    .popup-notice {
      width: 90%;
      font-size: 14px;
      padding: 10px;
      bottom: 10px;
    }

    .popup-notice.show {
      bottom: 20px;
    }
  }
`;
document.head.appendChild(style);
